module.exports = __webpack_public_path__ + "img/mahgoub.97f259ec.png";